import HouseholdProfile from "./HouseholdProfile"
export default HouseholdProfile
